import LArtwork from "@components/LArtwork";
import LBox from "@components/LBox";
import LText from "@components/LText";
import { AccessTypeOptions } from "@libs/utils";
import React from "react";
import {
  getAccessImage,
  prefetchAccessDetailHeroImage,
} from "@utils/accesses/access";
import { Access } from "@hooks/trpc/useAccesses";
import AccessTypeChip from "@components/Accesses/components/AccessTypeChip";
import LPressable from "@components/LPressable";
import { router } from "expo-router";

type MiniAccessCardProps = {
  access: {
    id: string;
    image?: string | null;
    artistName: string;
    dateTime?: string;
    venue?: string;
    city?: string;
    country?: string;
    type: AccessTypeOptions;
  } & Access;
};
const MiniAccessCard = ({ access }: MiniAccessCardProps) => {
  const width = 160;
  const title =
    access.type === "music"
      ? (access.songs.at(0)?.title ?? access.artistName)
      : access.artistName;

  const subtitle =
    access.type === "music"
      ? access.artistName
      : access.venue && access.city && access.country
        ? `${access.venue} (${access.city}, ${access.country})`
        : access.venue && access.city
          ? `${access.venue}, ${access.city}`
          : access.city && access.country
            ? `${access.city} • ${access.country}`
            : undefined;

  return (
    <LPressable
      onPress={() => {
        prefetchAccessDetailHeroImage(access);
        router.push(`/access/${access.id}`);
      }}
      sentryEventName="MiniAccessCard"
    >
      <LBox width={width} overflow="hidden" alignItems="center" gap="s2">
        <LBox borderRadius="m-l" overflow="hidden">
          <LArtwork
            url={getAccessImage(access)}
            width={width}
            height={120}
            imageStyle={{ flex: 1, aspectRatio: undefined }}
            imageSize="medium"
          />
          {access.dateTime && <DateCard date={access.dateTime} />}
          <AccessTypeChip access={access} placement="top-right" />
        </LBox>

        <LBox gap="s1" width="100%">
          <LText fontSize={14} fontWeight="600" numberOfLines={1}>
            {title.trim()}
          </LText>
          {subtitle && (
            <LText numberOfLines={1} fontSize={12} color="instructionsText">
              {subtitle}
            </LText>
          )}
        </LBox>
      </LBox>
    </LPressable>
  );
};

const DateCard = ({ date }: { date: string }) => {
  const month = new Date(date)
    .toLocaleString("default", { month: "short" })
    .toUpperCase();

  const day = new Date(date).getDate();

  return (
    <LBox
      position="absolute"
      height={32}
      width={32}
      borderRadius="m"
      justifyContent="center"
      alignItems="center"
      top={5}
      left={5}
      style={{
        backgroundColor: "rgba(0,0,0,0.7)",
      }}
    >
      <LText fontSize={10} fontWeight={600} lineHeight={12}>
        {month}
      </LText>
      <LText fontSize={10} fontWeight={600} lineHeight={12}>
        {day}
      </LText>
    </LBox>
  );
};

export default MiniAccessCard;
